import { Link } from "react-router-dom";

const quickLinks = [
  { label: "电影", path: "/category?type=movie" },
  { label: "电视剧", path: "/category?type=tv" },
  { label: "综艺", path: "/category?type=variety" },
  { label: "搜索", path: "/search" },
  { label: "关于我们", path: "/about" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 md:mt-24 bg-accent-950 text-foreground-800">
      <div className="mx-auto max-w-page px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-moon-fill text-xl"></i>
              </span>
              <span className="font-heading font-extrabold text-lg text-foreground-950">午夜免费视频</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 max-w-sm">
              一个专注午夜影视内容的免费高清视频门户，聚合电影、电视剧、综艺等多元资源，陪你在深夜发现值得看完的故事。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-accent-900/70 flex items-center justify-center text-foreground-700">
                <i className="ri-mail-line"></i>
              </span>
              <a href="mailto:hello@midnight-video.example.com" className="text-sm text-foreground-700 hover:text-primary-400 transition-colors">
                hello@midnight-video.example.com
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-heading font-bold text-foreground-950">
              <a href="#footer-nav">内容导航</a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="text-sm text-foreground-700 hover:text-primary-400 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-heading font-bold text-foreground-950">
              <a href="#footer-friend">友情链接</a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li><span className="text-sm text-foreground-700">午夜影评社区</span></li>
              <li><span className="text-sm text-foreground-700">深夜放映厅</span></li>
              <li><span className="text-sm text-foreground-700">影视资料库</span></li>
              <li><span className="text-sm text-foreground-700">独立导演计划</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-accent-800/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © {year} 午夜免费视频 MIDNIGHT. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-600">
            本站内容为演示用途，视频播放为界面展示，不提供真实视频流服务。
          </p>
        </div>
      </div>
    </footer>
  );
}